// @flow

import { getComponentSettings } from './main';

import { type State } from '../reducers';

type GlobalState = {
  componentSettings: State,
};

export type ReviewSettings = $PropertyType<State, 'review'>;
export const getReviewSettings = (state: GlobalState): ReviewSettings => {
  const { review } = getComponentSettings(state);
  if (!review) {
    throw new Error('Missing review settings in componentSettings store.');
  }
  return review;
};

type BasedOn = $PropertyType<ReviewSettings, 'based_on'>;
export const getBasedOn = (state: GlobalState): BasedOn => (
  getReviewSettings(state).based_on
);

type Reviews = $PropertyType<ReviewSettings, 'reviews'>;
export const getReviews = (state: GlobalState): Reviews => (
  getReviewSettings(state).reviews
);

type AllReviewsLinkText = $PropertyType<ReviewSettings, 'all_reviews_link_text'>;
export const getAllReviewsLinkText = (state: GlobalState): AllReviewsLinkText => (
  getReviewSettings(state).all_reviews_link_text
);

type Rating = $PropertyType<ReviewSettings, 'rating'>;
export const getRating = (state: GlobalState): Rating => (
  getReviewSettings(state).rating
);

type Score = $PropertyType<ReviewSettings, 'score'>;
export const getScore = (state: GlobalState): Score => (
  getReviewSettings(state).score
);

type ReviewCount = $PropertyType<ReviewSettings, 'review_count'>;
export const getReviewCount = (state: GlobalState): ReviewCount => (
  getReviewSettings(state).review_count
);
